import {Observable, Subscription} from 'rxjs';

import IVolumeStore from '../Interfaces/IVolumeStore';

const subscribeToConsumerVolume = (
    consumerVolume$: Observable<number>,
    volumeStore: IVolumeStore
): Subscription =>
    consumerVolume$
        .subscribe(level => volumeStore.actions.setLevel(level));

export default subscribeToConsumerVolume;